export const ROUTE_HOME = '/';
export const ROUTE_SECTION_EAT_FRESH = '/eat-fresh';
export const ROUTE_SECTION_STAY_ACTIVE = '/stay-active';
export const ROUTE_SECTION_BE_PRODUCTIVE = '/be-productive';
export const ROUTE_SECTION_REST = '/rest-and-rejuvenate';
export const ROUTE_SECTION_MY_DNA_PROFILE = '/my-dna-profile';
export const ROUTE_TRAIT_DETAILS = '/trait-details';
export const ROUTE_PDF_REPORT = '/profile/reports';

export const ROUTE_ABOUT = '/about';
export const ROUTE_PRIVACY = '/legal-and-privacy-policy';
export const ROUTE_TERMS = '/terms-and-conditions-of-use';
export const ROUTE_CONTACT = '/contact';
export const ROUTE_MY_PROFILE = '/my-profile';
export const ROUTE_ONBOARDING = '/onboarding';
